import React, { Component, useEffect } from 'react';
import {
  Button,
  Card,
  CardBody,
  CardSubtitle,
  CardTitle,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledTooltip,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { t } from 'ttag';

import EmptyState from '../../../commons/EmptyState';
import EmptyTypes from '../../../commons/EmptyTypes';
import SvgViewer from '../../../commons/SvgViewer';
import { ProgressButton } from '../../../commons/ProgressButton';
import Services from './Services';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import TimeFormatter from '../../../commons/TimeFormatter';
import JegyeladasFizetesButton from './JegyeladasFizetesButton';
import Loader from '../../../commons/loader';
import SelectField from '../../../components/Form/SelectField';
import NumberFormatter from '../../../commons/NumberFormatter';
import { flushSync } from 'react-dom';
import _ from 'lodash';

const CONSTANTS = {
  fizetesiModAzonositok: ['KP', 'UTA', 'PPOS'],
  fizetesiModSzinkodok: { KP: ['#ffeb0b', '#d7c900'], UTA: ['#ff710b', '#ce5600'], PPOS: ['#ffae0b', '#c48400'] }
};

let navigate = undefined;

class JegyeladasContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // [1,2,3,4]
      bucket: [],
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      pageStatus: 'LOAD',
      // ['CANCELED', 'SUCCEEDED']
      redirectStatus: ['SUCCEEDED'],
      currentStep: 1,
      isRendeles: false,
      buttonLoading: false,
      foglalasButtonLoading: false,
      fizetesButtonLoading: false,
      fizetesNyomtatasNelkulButtonLoading: false,
      visszatorlesButtonLoading: false,
      kedvezmenyButtonLoading: false,
      isOsszegzesNezet: false,
      activeSectors: [],
      selectedTickets: [],
      kedvezmenyList: [],
      activeKedvezmeny: {
        azonosito: null,
        ertek: null,
        ervenyes: false,
        id: null,
        nev: null,
        szazalek: null,
      },
      currentSeatId: null,
      currentDiscountId: null,
      bucketPrice: 0,
      bucketPieces: 0,
      formVasarloiKartyaBySid: {},
      formKedvezmenyListByJegyTipus: {},
      formKedvezmenyValueBySid: {},
      formAlanyMap: {},
      formNev: '',
      formEmail: '',
      formBizonylatszam: '',
      formMegjegyzes: '',
      formRot: '',
      formMegvasarlas: false,
      formFoglalas: false,
      formCurrentPayment: null,
      formBarion: false,
      redirectUrl: "http://192.168.2.179:8288/jegy/event/38c502a56828c5a3fa05be070f1637e2",
      isControlActive: false,
      isJegytipusPanelOpen: false,
      isFoglalasModalOpen: false,
      formFizetesiMod: null,
      // formKedvezmenyListSzemely: [],
      aktivRendeles: null,
      foglalasButtonLoading: false,
      event: {
        eru: '',
        ecu: '',
        cid: undefined,
        des: undefined,
        eid: undefined,
        end: undefined,
        lid: undefined,
        nam: undefined,
        res: undefined,
        sta: undefined,
        otl: undefined,
      },
      layout: {
        bix: 0,
        bax: 0,
        areas: [],
        blocks: [],
        cod: undefined,
        hid: undefined,
        hna: undefined,
        lid: undefined,
        nam: undefined,
        str: {},
        texts: [],
        vad: undefined,
        vna: undefined
      },
      init: {
        sectors: [],
        now: '',
        rot: [],
        pty: []
      },
      rot: {
        name: null
      },
      tickets: [],
      rendeles: {
        gatewayUrl: '',
        rendeles: {},
        rendelesadat: {
          jegyadatok: []
        }
      },
      defaultCurrency: '',
      loc: undefined,
      navigate: undefined,
      prevProps: undefined,
      rendelesSnapshot: [],
      aktivRendelesLoading: false,
      aktivRendelesId: null,
      ron: null,
    };
  }

  onKeyDown = (e) => {
    if (e.key === 'Control' && e.key !== 'AltGraph') {
      this.setState({
        isControlActive: true
      });
    }
  }

  onKeyUp = (e) => {
    if (e.key === 'Control' && e.key !== 'AltGraph') {
      this.setState({
        isControlActive: false
      })
    }
  }

  deleteOrder = (event) => {
    if(this.state.foglalasButtonLoading) return;

    event.preventDefault();
    event.returnValue = '';
    if (this.state.event.rid) {
      Services.deleteOrder(this.state.event.rid, this.state.eszkozazonosito, true, (err, res) => {
        if (!err) {
        }
      });
    } else {
      Services.wsSend('/kulsomonitor',this.state.eszkozazonosito, (err, res) => {
        if (!err) {
          this.goBack();
        }
      });
    }
  }

  componentDidMount() {
    console.log('JEGYELADAS PROPS: ',  this.props.globals);

    const rendelesId = window.location.search ? (new URLSearchParams(window.location.search)).get('rendelesId') : null;
    if(rendelesId) {
      this.loadRendeles(rendelesId);
    }

    if (this.props && this.props.rendelesId) {
      this.setState({
        isRendeles: true,
        isOsszegzesNezet: true
      });
      this.loadPayData();
    } else {
      this.loadData();
    }

    Services.getDefaultCurrency((err, res) => {
      if (!err) {
        this.setState({ defaultCurrency: res[0].azonosito });
      }
    });

    window.addEventListener('keydown', this.onKeyDown, true);
    window.addEventListener('keyup', this.onKeyUp, true);
    window.addEventListener('beforeunload', e => this.deleteOrder(e), false);
    window.addEventListener('popstate', e => this.deleteOrder(e), false);

    document.body.classList.add("sidebar-hidden");
    // return null;
  }

  loadRendeles = (rendelesId) => {
    this.setState({ aktivRendelesLoading: true }, () => {
      let rendelesSnapshot = [];
      let jegyekToroltNelkul = [];
      Services.getRendeles(rendelesId, (err, res) => {
        if(!err) {
          
          rendelesSnapshot = res[0].jegyadatok.filter(jegyek => jegyek.jegyAllapot !==  "Törölt").map(jegy => ({ id: jegy.id, jegyTipus: jegy.jegyTipus, jegyAllapot: jegy.jegyAllapot }) );
          jegyekToroltNelkul = res[0].jegyadatok.filter(jegyek => jegyek.jegyAllapot !==  "Törölt");
          res[0].jegyadatok = jegyekToroltNelkul;
          console.log('res[0]', res[0] , rendelesSnapshot)
          this.setState({
            rendelesSnapshot,
            aktivRendeles: res[0],
            aktivRendelesLoading: false, 
            aktivRendelesId: rendelesId,
            ron: res[0].rendelesSorszam
          });
          console.log('loadrendeles')
          document.body.classList.add("sidebar-hidden");
        }
      });
    })
  }

  // componentDidMount() {
  //   const history = this.props.history;
  //   console.log(navigate)
  //   if (history && history.location && history.location.state && history.location.state.rendelesId) {
  //     this.setState({
  //       isRendeles: true,
  //       isOsszegzesNezet: true
  //     });
  //     this.loadPayData(history.location.state.rendelesId);
  //   } else {
  //     this.loadData();
  //   }

  //   Services.getDefaultCurrency((err, res) => {
  //     if (!err) {
  //       this.setState({ defaultCurrency: res[0].azonosito });
  //     }
  //   });

  //   window.addEventListener('keydown', this.onKeyDown, false);
  //   window.addEventListener('keyup', this.onKeyUp, false);
  //   window.addEventListener('beforeunload', e => this.deleteOrder(e), false);
  //   window.addEventListener('popstate', e => this.deleteOrder(e), false);
  // }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown, true);
    window.removeEventListener('keyup', this.onKeyUp, true);
    window.removeEventListener("beforeunload", (e) => this.deleteOrder(e), false);
    window.removeEventListener("popstate", (e) => this.deleteOrder(e), false);
  }

  toggleFoglalasModal = () => {
    if (!this.state.isFoglalasModalOpen) {
      window.removeEventListener('keydown', this.onKeyDown, true);
      window.removeEventListener('keyup', this.onKeyUp, true);
      this.setState({
        isControlActive: false
      })
    } else {
      window.addEventListener('keydown', this.onKeyDown, true);
      window.addEventListener('keyup', this.onKeyUp, true);
    }
    this.setState(prevState => ({ isFoglalasModalOpen: !prevState.isFoglalasModalOpen }));
  }

  toggleKedvezmenyModal = () => {
    this.setState(prevState => ({ isKedvezmenyModalOpen: !prevState.isKedvezmenyModalOpen }));
  }

  toggleJegytipusPanel = () => {
    this.setState(prevState => ({
      isJegytipusPanelOpen: !prevState.isJegytipusPanelOpen
    }));
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleVasarloiKartyaChange = (id, item) => {
    const { idn, sid } = item;
    if (id) {
      /* Lásd loadVasarloiKartyaOptions()
      Az eredeti bonyolult és dinamikus adatszerkezet, valamint funkcionalitás utólag és fokozatosan egyszerűsítésre került az ügyfél kérésére, és idő hiányában az adatszerkezet nem került átdolgozásra
      Az ererdményben szereplő "jegy"-ek jegytípusonként("idn") vannak felsorolva (.jegy[idn]), és ezekből az elsőt ki kell választani ha összesen egy van csak
      res[0] adatszerkezetre példa:
      {
        jegy: {
          3D: {
            0: {...},
            1: {...}
          }
        }
      }
      */
      Services.listKedvezmenyByJegytipusAndVasarloiKartya(idn, id, (err, res) => {
        if (!err) {
          this.setState((prevState) => {
            let { formKedvezmenyListByJegyTipus, formKedvezmenyValueBySid } = prevState;
            if (res[0].jegy && res[0].jegy[idn]) {
              res[0].jegy[idn].sort((a, b) => a.nev.localeCompare(b.nev));
            }
            formKedvezmenyListByJegyTipus[sid] = res[0].jegy;
            if (res[0].jegy && res[0].jegy[idn] && res[0].jegy[idn].length == 1) {
              let id = res[0].jegy[idn][0].id;
              formKedvezmenyValueBySid[sid] = id;
              this.handleKedvezmenyChange(id, item)
            } else {
              formKedvezmenyValueBySid[sid] = null;
            }
          return {
            formKedvezmenyListByJegyTipus, formKedvezmenyValueBySid
          }});
        }
      });
    } else {
      this.setState((prevState) => {
        let { formKedvezmenyListByJegyTipus, formKedvezmenyValueBySid } = prevState;
        formKedvezmenyListByJegyTipus[sid] = {};
        formKedvezmenyValueBySid[sid] = null;
        this.handleKedvezmenyChange(null, item);
        return {
          formKedvezmenyListByJegyTipus, formKedvezmenyValueBySid
        }
      });
    }
  }

  handleKedvezmenyInputChange = (e, sid, item) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const bucket = JSON.parse(JSON.stringify(this.state.bucket));
    let newBucket = [];

    bucket.forEach((bucketItem) => {
      if (bucketItem.sid === sid) {
        bucketItem.did = value;
      }
      newBucket.push(bucketItem);
    });

    this.setState({
      bucket: newBucket
    });
  }

  getTicketTypeByTicketId = (ticketSector) => {
    let tickets = JSON.parse(JSON.stringify(this.state.tickets));
    let activeSectors = JSON.parse(JSON.stringify(this.state.activeSectors));
    let result = -1;

    // console.log(ticketSector);
    // console.log(tickets);
    // console.log(activeSectors);

    tickets.forEach((ticket) => {
      if ((ticket.sec === ticketSector)) result = { sec: ticketSector, pri: ticket.pri, nam: ticket.nam, idn: ticket.idn, cur: ticket.cur };
    });

    return result;
  }

  isTicketInBucket = (tid, deletedTickets) => {
    let hasTalalat = false;
    deletedTickets.forEach((element) => {
      if (tid === element.tid) hasTalalat = true;
    });

    return hasTalalat;
  }

  hasNewSeat = () => {
    let hasNew = false;

    let layout = JSON.parse(JSON.stringify(this.state.layout));
    layout.blocks.forEach((block, idx) => {
      block.seats.forEach(seat => {
        if (seat.new ) hasNew = true;
      });
    });
    return hasNew;
  }

  isRendelesEdited = () => {
    let result = false;

    if(this.state.aktivRendeles) {
      let aktivRendelesCopy = JSON.parse(JSON.stringify(this.state.aktivRendeles.jegyadatok));
      let rendelesSnapshotCopy = JSON.parse(JSON.stringify(this.state.rendelesSnapshot));
  
      if(aktivRendelesCopy.length !== rendelesSnapshotCopy.length) result = true;

      aktivRendelesCopy.forEach(aktiv => {
        rendelesSnapshotCopy.forEach(snap => {
          if(aktiv.id == snap.id) {
            if (aktiv.jegyTipus != snap.jegyTipus) result = true;
          }
        });
      });

      console.log('edited', aktivRendelesCopy, rendelesSnapshotCopy, result)

    }

    
    return result;
  }

  onTicketClick = (ticket, row, rowLabel, hasGroup, seatPrefix, seatSufix, blockPrefix) => {
    // console.log('Control: ', this.state.isControlActive);
    console.log('TICKET', ticket)
    // console.log('ROW', row)


    if('rid' in ticket && ticket['rid']) {
      //if(!this.state.aktivRendeles && this.state.bucket.length < 1) {

      if((!this.hasNewSeat()) && (!this.isRendelesEdited())) {
        //rendelesSnapshot
        console.log('aktivRendeles', this.state.aktivRendeles, this.state.bucket)
        this.setState({
          ron: null,
          aktivRendeles: null,
        }, () => {
          this.loadRendeles(ticket.rid);
        })
      } else {
        if(this.hasNewSeat() || this.isRendelesEdited()) {
          if(this.state.aktivRendeles) this.props.globals.addWarning('Módosult a rendelés!');
        }
      }
        
     // }
      return;
    }
    let aktiv = true;
    let skippBucket = false;
    let isDelete = false;
    let blockIdx = 0;
    let layout = JSON.parse(JSON.stringify(this.state.layout));
    layout.blocks.forEach((block, idx) => {
      block.seats.forEach(seat => {
        if (seat.tid === ticket.tid) {
          if (seat.new) isDelete = true;
          blockIdx = idx;
          if(!seat.new && (this.state.aktivRendeles && ((this.state.aktivRendeles.rendelesAllapot !== "Lefoglalt") && (this.state.aktivRendeles.rendelesAllapot !== "Foglalás részben törölve (Sikeres foglalás utáni)")))) {
            if(this.state.aktivRendeles.rendelesAllapot === "Sikeres fizetés" || 
            this.state.aktivRendeles.rendelesAllapot === "Jegy(ek) átadva" ||
            this.state.aktivRendeles.rendelesAllapot === "Vásárlás részben törölve (Sikeres vásárlás utáni)") {
              this.setState({
                ron: null,
                aktivRendeles: null,
                aktivRendelesLoading: false,
                aktivRendelesId: null,
              });
              seat.new = true;
              aktiv = false;
            } else {
              skippBucket = true;
            }
            return;
          } else {
            seat.new = !seat.new;
          }

        }
      });
    });

    if (hasGroup || this.state.isControlActive) {
      layout.blocks[blockIdx].seats.forEach(element => {
        if (isDelete) {
          if (!element.col[1]){
            element.new = false
          }
        } else {
          if (!element.col[1]){
          element.new = true
          }
        }
      });
    }

    if (isDelete) {
      if (hasGroup || this.state.isControlActive) {
        let deletedTickets = [];
        layout.blocks.forEach(block => {
          block.seats.forEach(seat => {
            if (seat.tid === ticket.tid) {
              deletedTickets = block.seats;
            }
          });
        });
        let bucket = JSON.parse(JSON.stringify(this.state.bucket));
        let filteredBucket = bucket.filter((item, index) => {
          return !this.isTicketInBucket(item.sid, deletedTickets)
        })
        this.setState(prevState => ({
          bucket: filteredBucket,
          layout: layout
        }), () => {
          this.props.changePortalData(this.state.layout, this.state.init, this.state.event);
        });
      } else {
        this.setState(prevState => ({
          bucket: prevState.bucket.filter(bucketItem => bucketItem.sid !== ticket.tid),
          layout: layout,
          // TODO DELETE
          bucketPrice: prevState.bucketPrice - 1000,
          bucketPieces: prevState.bucketPieces - 1
        }), () => {
          this.props.changePortalData(this.state.layout, this.state.init, this.state.event)
        });
      }
    } else {

      // TODO PROTO

      if (hasGroup || this.state.isControlActive) {
        console.log("UK1")
        let newTickets = [];
        layout.blocks.forEach(block => {
          block.seats.forEach(seat => {
            if (seat.tid === ticket.tid) {
              newTickets = block.seats.filter(s => !this.state.bucket.map(b => b.sid).includes(s.tid));
            }
          });
        });
        let newDetailedTickets = [];
        newTickets.forEach((item) => {
          // console.log(item.lab, item.col[1])
          if (!item.col[1]) {
            newDetailedTickets.push({
              rowLabel: rowLabel,
              lbp: blockPrefix,
              lss: seatSufix,
              lsp: seatPrefix,
              lab: item.lab,
              sid: item.tid,
              tid: this.getTicketTypeByTicketId(item.sec).sec,
              pri: 0,
              nam: this.getTicketTypeByTicketId(item.sec).nam,
              idn: this.getTicketTypeByTicketId(item.sec).idn,
              cur: this.getTicketTypeByTicketId(item.sec).cur,
            })
          }
        })
        // console.log(newDetailedTickets)
        this.setState(prevState => ({
          bucket: prevState.bucket.concat(newDetailedTickets),
          layout: layout
        }), () => {
          this.props.changePortalData(this.state.layout, this.state.init, this.state.event)
        });
      } else {
        console.log("UK2", this.state.bucket, skippBucket)
        if(!skippBucket) {
          this.setState(prevState => ({
            bucket: [...prevState.bucket,
              {
                rowLabel: rowLabel,
                lab: ticket.lab,
                lbp: blockPrefix,
                lss: seatSufix,
                lsp: seatPrefix,
                sid: ticket.tid,
                tid: this.getTicketTypeByTicketId(ticket.sec).sec,
                pri: 0,
                nam: this.getTicketTypeByTicketId(ticket.sec).nam,
                idn: this.getTicketTypeByTicketId(ticket.sec).idn,
                cur: this.getTicketTypeByTicketId(ticket.sec).cur,
              }
            ],
            layout: layout,
            // TODO DELETE
            bucketPrice: prevState.bucketPrice + 1000,
            bucketPieces: prevState.bucketPieces + 1
          }), () => {
            console.log("UK4", this.state.bucket)
            this.props.changePortalData(this.state.layout, this.state.init, this.state.event)
          });
        }
      }

      // END PROTO

      // if (this.getTicketTypeByTicketId(ticket.sec) === -1 ) {
      //   this.props.globals.addError('Ülőhely választáshoz jegytípus választása kötelező!')
      // } else {
      //   if (hasGroup || this.state.isControlActive) {
      //     let newTickets = [];
      //     layout.blocks.forEach(block => {
      //       block.seats.forEach(seat => {
      //         if (seat.tid === ticket.tid) {
      //           newTickets = block.seats.filter(s => !this.state.bucket.map(b => b.sid).includes(s.tid));
      //         }
      //       });
      //     });
      //     let newDetailedTickets = [];
      //     newTickets.forEach((item) => {
      //       if (!item.res) {
      //         newDetailedTickets.push({
      //           rowLabel: rowLabel,
      //           lab: item.lab,
      //           sid: item.tid,
      //           tid: this.getTicketTypeByTicketId(item.sec).sec,
      //           pri: this.getTicketTypeByTicketId(item.sec).pri,
      //           nam: this.getTicketTypeByTicketId(item.sec).nam,
      //         })
      //       }
      //     })
      //     console.log(newDetailedTickets)
      //     this.setState(prevState => ({
      //       bucket: prevState.bucket.concat(newDetailedTickets),
      //       layout: layout
      //     }));
      //   } else {
      //     this.setState(prevState => ({
      //       bucket: [...prevState.bucket,
      //         {
      //           rowLabel: rowLabel,
      //           lab: ticket.lab,
      //           sid: ticket.tid,
      //           tid: this.getTicketTypeByTicketId(ticket.sec).sec,
      //           pri: this.getTicketTypeByTicketId(ticket.sec).pri,
      //           nam: this.getTicketTypeByTicketId(ticket.sec).nam,
      //         }
      //       ],
      //       layout: layout
      //     }));
      //   }
      // }
    }

    let activeTickets = [];

    if(this.state.isControlActive) {
      if(isDelete) {
        layout.blocks.forEach(block => {
          block.seats.forEach(seat => {
            if (seat.tid === ticket.tid) {
              activeTickets = block.seats;
            }
          });
        });
        activeTickets = activeTickets.filter(x => !('rid' in x));
      } else {
        layout.blocks.forEach(block => {
          block.seats.forEach(seat => {
            if (seat.tid === ticket.tid) {
              activeTickets = block.seats.filter(s => !this.state.bucket.map(b => b.sid).includes(s.tid));
            }
          });
        });

        activeTickets = activeTickets.filter(x => !('rid' in x));
        isDelete = activeTickets.every(x => x.col[1]);

        if(!isDelete) activeTickets = activeTickets.filter(x => !x.col[1]);
      }
    } else {
      if((this.state.aktivRendeles && ((this.state.aktivRendeles.rendelesAllapot !== "Lefoglalt") && (this.state.aktivRendeles.rendelesAllapot !== "Foglalás részben törölve (Sikeres foglalás utáni)")))) {
        
      } else {
        activeTickets = [ticket];
      }
      
    }

    console.log('aKT1', this.state.aktivRendeles, activeTickets)

    if(this.state.aktivRendeles && aktiv) {
      this.setState(prev => ({
        aktivRendeles: {
          ...prev.aktivRendeles,
          jegyadatok: isDelete
            ? prev.aktivRendeles.jegyadatok.filter(t => !activeTickets.map(x => x.tid).includes(t.helyId))
            : [
              ...prev.aktivRendeles.jegyadatok,
              ...activeTickets.map(ticket => ({
                "helyId": ticket.tid,
                "szektorId": this.getTicketTypeByTicketId(ticket.sec).sec,
                "jegySor": rowLabel,
                "jegySzek": `${ticket.lab}. szék`,
                "jegyTipus": this.getTicketTypeByTicketId(ticket.sec).nam,
                "jegyAr": 0,
                "jegySorszam": ticket.lab,
                "jegyAllapot": "Létrehozott",
              }))
            ],
        }
      }));
    }

    console.log('aKT2', this.state.aktivRendeles)
  }

  getTicketTypeById = (id, tickettypes) => {
    let resultItem = null;

    tickettypes.forEach(tickettype => {
      if (tickettype.tid === id) {
        resultItem = tickettype;
      }
    });

    return resultItem;
  }

  getLayoutDataById = (id, blocks) => {
    let resultItem = null;

    blocks.forEach(block => {
      block.seats.forEach(seat => {
        if (seat.tid === id){
          resultItem = {
            rowLabel: block.lab,
            lab: seat.lab,
            lss: seat.lss,
            lsp: seat.lsp,
          }
        }
      });
    });

    return resultItem;
  }

  loadData = () => {
    const {
      eventId,
    } = this.props;
    this.setState({
      pageStatus: 'LOAD',
    }, () => {
      var eszkozazonosito = null;
      if(localStorage && localStorage.eszkozazonosito && localStorage.eszkozazonosito !== null) {
        eszkozazonosito = localStorage.getItem("eszkozazonosito");
      }
      Services.getAdminEvent(eventId,CONSTANTS.fizetesiModAzonositok, eszkozazonosito, (err, res) => {
        if (!err) {
          this.setState({
            eszkozazonosito: eszkozazonosito,
            tickets: res[0].tickets,
            event: res[0].event,
            layout: res[0].layout,
            init: res[0].init,
            pageStatus: 'DATA'
          }, () =>{
            this.props.changePortalData(res[0].layout, res[0].init, res[0].event)
          });
      };
    });
    });
  }

  loadPayData = () => {
    const {
      rendelesId,
    } = this.props;

    this.setState({
      pageStatus: 'LOAD',
    }, () => {
      Services.getErtekesitesPay(rendelesId, CONSTANTS.fizetesiModAzonositok, (err, res) => {
        if (!err) {
          let event = res[0].event.event;
          event.eid = res[0].order.eid;
          event.rid = res[0].order.rid;
          event.ron = res[0].order.ron;

          let init = res[0].event.init;
          init.now = res[0].order.now;

          let seattickets = res[0].order.seattickets;
          let resultSeats = [];

          seattickets.forEach(ticket => {
            let ticketTypeData = this.getTicketTypeById(ticket.tid, res[0].event.tickets);
            let layoutData = this.getLayoutDataById(ticket.sid, res[0].event.layout.blocks);

            resultSeats.push({
              id: ticket.id,
              tdi: null,
              sid: ticket.sid,
              ttid: ticket.tid,
              tid: ticketTypeData.sec,
              nam: ticketTypeData.nam,
              idn: ticketTypeData.idn,
              pri: ticketTypeData.pri,
              dis: ticketTypeData.dis,
              rowLabel: layoutData.rowLabel,
              lab: layoutData.lab,
              lss: layoutData.lss,
              lbp: layoutData.lbp,
              lsp: layoutData.lsp,
            });
          });

          this.setState({
            bucket: resultSeats,
            tickets: res[0].event.tickets,
            event: event,
            layout: res[0].event.layout,
            init: init,
            formNev: res[0].order.nam,
            formEmail: res[0].order.ema,
            formBizonylatszam: res[0].order.rno,
            formMegjegyzes: res[0].order.not,
            rot: res[0].order.rot,
            ros: res[0].order.ros,
            ron: res[0].order.ron,
            isOsszegzesNezet: true,
            pageStatus: 'DATA'
          }, () => {
            // window.addEventListener("beforeunload", (e) => this.deleteOrder(e), false);
            // window.addEventListener("popstate", (e) => this.deleteOrder(e), false);
          });
        }
      });
    }
    )
  }

  onLogout = () => {
    this.props.globals.logout();
  }

  emptyFormatter = (data) => {
    if (!data || data === '') return '-';
    return data;
  }

  hasSelectedTicket = () => {
    let selectedSectorId = undefined;

    if(this.state.aktivRendeles) {
      this.state.aktivRendeles.jegyadatok.forEach((bucketItem) => {
        if(bucketItem.selected) {
          selectedSectorId = bucketItem.szektorId;
        }
      });
    } else {
      this.state.bucket.forEach((bucketItem) => {
        if (bucketItem.selected){
          selectedSectorId = bucketItem.tid;
        }
      });
    }

    return selectedSectorId;
  }

  isSectorChanged = (sectorId) => {
    let isSectorChanged = false;
    this.state.bucket.forEach((ticket) => {
      if ((ticket.selected) && (ticket.tid !== sectorId)) isSectorChanged=true;
    })
    return isSectorChanged;
  }

  hasElementWithId = (array, id) => {
    let hasElement = false;
    array.forEach(element => {
      if (element.sid === id) {
        hasElement = true;
      }
    });

    return hasElement;
  }

  isAllTicketSelected = (tickets) => {
    let result = true;

    tickets.forEach(element => {
      if (!element.sel) {
        result = false;
      }
    });

    return result;
  }

  onSectorTicketsSelect = (selectedTickets) => {
    if(((!this.state.aktivRendeles) || (this.state.aktivRendeles && (this.state.aktivRendeles.rendelesAllapot === "Lefoglalt" || this.state.aktivRendeles.rendelesAllapot === "Foglalás részben törölve (Sikeres foglalás utáni)")))) {
      if(this.state.aktivRendeles) {
        const isAllSelected = this.state.aktivRendeles.jegyadatok.every(x => x.selected);
        this.setState({
          aktivRendeles: {
            ...this.state.aktivRendeles,
            jegyadatok: this.state.aktivRendeles.jegyadatok.map(x => ({ ...x, selected: !isAllSelected }))
          },
        })
        return;
      }

      const bucket = JSON.parse(JSON.stringify(this.state.bucket));
      let newBucket = [];

      if (this.isAllTicketSelected(selectedTickets)) {
        bucket.forEach(bucketItem => {
          bucketItem.selected = false;
          newBucket.push(bucketItem);
        });
      } else {
        bucket.forEach(bucketItem => {
          if (this.hasElementWithId(selectedTickets, bucketItem.sid)) {
            // console.log('SELECTEDTICKETS', selectedTickets);
            bucketItem.selected = true;
          } else {
            bucketItem.selected = false;
          }
          newBucket.push(bucketItem);
        });
      }

      this.setState({
        bucket: newBucket
      });
    }
  }

  onTicketDelete = (ticket, idx) => {
    const newLayout = structuredClone(this.state.layout);
    const blockIdx = newLayout.blocks.findIndex(x => x.lab === ticket.rowLabel);
    if(blockIdx >= 0) {
      newLayout.blocks[blockIdx].seats = newLayout.blocks[blockIdx].seats.map(x => x.tid == ticket.sid ? ({ ...x, col: ['008000', false], new: false, rid: undefined }) : x);
    }

    this.setState({
      bucket: this.state.bucket.filter((t) => t.sid !== ticket.sid),
      layout: newLayout,
      aktivRendeles: this.state.aktivRendeles ? {
        ...this.state.aktivRendeles,
        jegyadatok: this.state.aktivRendeles.jegyadatok.filter(i => i.helyId !== ticket.sid)
      } : null,
    });
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete, formTorlesOka: '' }));
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  handleDeleteClick = (cell) => {
    this.setState({
      torlesId: cell
    }, () => {
      Services.checkRendelesDelete([cell], (err, res) => {
        if (!err) {
          this.setState({
            hasTorlesOka: res[0].result
          }, () => {
            this.toggleDeleteModal();
          })
        }
      });
    });
  }

  deleteRendeles = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deleteRendelesFrom(this.state.torlesId, this.emptyOrNull(this.state.formTorlesOka), (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.props.globals.addSuccess('Rendelés törölve!');
        this.props.dismissPortal();
        document.body.classList.remove("sidebar-hidden");
        this.props.globals.route.navigate(`${this.props.globals.public_url}/admin/jegyertekesites/helysziniertekesites`);
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }

  onRendelesTicketSelect = (sid) => {
    this.setState({
      bucket: this.state.bucket.map(i => i.sid === sid ? ({ ...i, selected: !i.selected }) : i),
      aktivRendeles: {
        ...this.state.aktivRendeles,
        jegyadatok: this.state.aktivRendeles.jegyadatok.map(i => i.helyId === sid ? ({ ...i, sel: !i.sel, selected: !i.selected }) : i)
      },
    });
  }

  onTicketSelect = (sid) => {
    const bucket = JSON.parse(JSON.stringify(this.state.bucket));
    let newBucket = [];
    let isSectorChanged = false;
    let selectedItemId = -1;

    bucket.forEach((bucketItem) => {
      if (bucketItem.sid === sid){
        if (this.isSectorChanged(bucketItem.tid)) {
          isSectorChanged = true;
          selectedItemId = bucketItem.sid;
        } else {
          bucketItem.selected = !bucketItem.selected
        }
      }
      newBucket.push(bucketItem);
    });

    if (isSectorChanged) {
      newBucket.forEach((bucketItem) => {
        if (bucketItem.sid === selectedItemId){
          bucketItem.selected = true;
        } else {
          bucketItem.selected = false;
        }
      });
    }

    this.setState({
      bucket: newBucket
    });
  }

  renderBucket = () => {
    const {
      init,
      bucket,
      aktivRendeles
    } = this.state;

    let bucketDOM = [];

    if(aktivRendeles) {
      init.sectors.forEach((sector) => {
        let elementsBySector = [];

        aktivRendeles.jegyadatok.forEach(ticket => {
          //if (ticket.jegyAllapot === 'Létrehozott' && ticket.szektorId == sector.id) elementsBySector.push({
          if (ticket.szektorId == sector.id) elementsBySector.push({
            lab: null,
            rowLabel: ticket.jegySor,
            lss: ticket.jegySzek,
            lbp: null,
            lsp: null,
            tid: ticket.szektorId,
            sid: ticket.helyId,
            pri: ticket.jegyAr,
            nam: ticket.jegyTipus,
            sel: ticket.selected ?? false,
            selected: ticket.selected ?? false,
            ttid: ticket.jegyTipusId,
            ttn: ticket.jegyTipus,
          });
        });

        bucketDOM.push({
          name: sector.nam,
          id: sector.id,
          color: sector.col,
          elements: elementsBySector
        });
      })
    } else {
      init.sectors.forEach((sector) => {
        let elementsBySector = [];

        bucket.forEach((ticket) => {
          if (ticket.tid === sector.id) elementsBySector.push({
            lab: ticket.lab,
            ttid: ticket.ttid,
            ttn: ticket.ttn,
            rowLabel: ticket.rowLabel,
            lss: ticket.lss,
            lbp: ticket.lbp,
            lsp: ticket.lsp,
            tid: ticket.tid,
            sid: ticket.sid,
            pri: ticket.pri,
            nam: ticket.nam,
            sel: ticket.selected
          });
        });

        bucketDOM.push({
          name: sector.nam,
          id: sector.id,
          color: sector.col,
          elements: elementsBySector
        });
      })
    }

    // console.log('||||||| BUCKET MAP |||||||||');
    // console.log(bucketDOM);
    console.log('aktivRendeles', aktivRendeles)

    return bucketDOM.map((bucketItem) => {
        let isBucketItemEmpty = bucketItem.elements.length === 0
        return (
          !isBucketItemEmpty && (
            <React.Fragment>
              <h6>
                {bucketItem.name + ': '}
                <i
                  className="fa fa-check-square-o"
                  aria-hidden="true"
                  style={{ cursor: 'pointer', marginTop: 12, marginLeft: 4 }}
                  onClick={() => this.onSectorTicketsSelect(bucketItem.elements)}
                />
              </h6>
              <div className="row">
                
                {bucketItem.elements.map((ticket, idx) => {
                  return (
                    <div className="col-md-12 noselect">
                      <div
                        className='d-flex align-items-center justify-content-between'
                        style={{
                          padding: 7,
                          border: '1px solid #e4e4e4',
                          marginBottom: 6,
                          cursor: ((!aktivRendeles) || (aktivRendeles && (aktivRendeles.rendelesAllapot === "Lefoglalt" || aktivRendeles.rendelesAllapot === "Foglalás részben törölve (Sikeres foglalás utáni)"))) ? 'pointer' : 'not-allowed',
                          backgroundColor: ticket.sel ? '#ffeabe' : 'white'
                        }}
                        onClick={() => {
                          if(((!aktivRendeles) || (aktivRendeles && (aktivRendeles.rendelesAllapot === "Lefoglalt" || aktivRendeles.rendelesAllapot === "Foglalás részben törölve (Sikeres foglalás utáni)")))) {
                            this.state.aktivRendeles ? this.onRendelesTicketSelect(ticket.sid) : this.onTicketSelect(ticket.sid);
                          }
                          
                        }}
                        // onClick={() => this.onTicketSelect(ticket.sid)}
                      >
                        <div>
                          {/*<b>{t`Szektor:`}</b><span>{' ' + 'TODO' + ', '}</span> */}
                          <b>{t`Hely:`}</b><span>{' ' + (ticket.lbp ? ticket.lbp : ' ') + ' ' + (ticket.rowLabel || '') + ', ' + (ticket.lsp ? ticket.lsp : '') + ' ' + (ticket.lab || '') + (ticket.lss ? ticket.lss : ' ') }</span>
                          <br />
                          <b>{t`Jegytípus:`}</b><span>{' ' + (ticket.ttid ? (ticket.ttn + ' | ' + NumberFormatter.formatterSpaceOsszeg(ticket.pri) + ' ' + this.state.defaultCurrency) : '-')}</span>
                        </div>

                        {((!aktivRendeles) || (aktivRendeles && (aktivRendeles.rendelesAllapot === "Lefoglalt" || aktivRendeles.rendelesAllapot === "Foglalás részben törölve (Sikeres foglalás utáni)"))) && (
                          <React.Fragment>
                            <Button
                              className="icon-trash table-action-icon"
                              id={'ticket-' + idx.toString() + '-torles'}
                              style={{ fontSize: 16, padding: '4px 6px' }}
                              onClick={e => {
                                e.stopPropagation();
                                this.onTicketDelete(ticket, idx);
                              }}
                            />
                            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'ticket-' + idx.toString() + '-torles'} delay={0}>Törlés</UncontrolledTooltip>
                          </React.Fragment>
                        )}
                        
                      </div>
                    </div>
                  )
                })}
              </div>
            </React.Fragment>
          )
        )
    })
  }

  setJegytipusok = (ticketTypeId, ticketTypeName, ticketPrice, ticketDiscount, ticketTypeIdentifier) => {
    if(this.state.aktivRendeles) {
      this.setState({
        aktivRendeles: {
          ...this.state.aktivRendeles,
          jegyadatok: this.state.aktivRendeles.jegyadatok.map(i => i.selected ? ({ ...i, jegyTipusId: ticketTypeId, jegyTipus: ticketTypeName, jegyAr: ticketPrice, jegyKedvezmenyNev: ticketDiscount, sel: false, selected: false }) : i)
        },
      });
    } else {
      let bucket = JSON.parse(JSON.stringify(this.state.bucket));
      let newBucket = [];

      bucket.forEach(bucketItem => {
        if (bucketItem.selected) {
          bucketItem.selected = false;
          bucketItem.ttid = ticketTypeId;
          bucketItem.ttn = ticketTypeName;
          bucketItem.pri = ticketPrice;
          bucketItem.dis = ticketDiscount;
          bucketItem.idn = ticketTypeIdentifier;
        }
          newBucket.push(bucketItem);
      });

      this.setState({
        bucket: newBucket
      });
    }
  }

  getTicketTypesBySector = (sector) => {
    return this.state.tickets.map(ticket => {
      if (ticket.sec === sector) {
        return <option value={ticket.tid}>{ticket.nam + ' | ' + NumberFormatter.formatterSpaceOsszeg(ticket.pri) + ' ' + ticket.cur}</option>
      }
    })
  }

  getKedvezmenyByJegytipus = (idn, sid) => {
    let options = [];
    let stateObj = this.state.formKedvezmenyListByJegyTipus[sid] || {};
    let kedvezmenyList = stateObj[idn];
    if (kedvezmenyList && kedvezmenyList.length > 0) {
      options = [...options, kedvezmenyList.map(kedvezmeny => <option value={kedvezmeny.id}>{kedvezmeny.nev}{' (' + NumberFormatter.formatterSpaceOsszeg(kedvezmeny.mertek) + ')'}</option>)]
    }
    // if (this.state.formKedvezmenyListSzemely.length > 0)
    //   // Csak olyan személyi kedvezmények vannak mutatva, ami már ki van választva, hogy ne lehessen kettő különböző személy kedvezményét beválasztani
    //   options = [...options, this.state.formKedvezmenyListSzemely.filter(kedvezmeny => !this.state.formAlanyId || kedvezmeny.alanyId == this.state.formAlanyId).map(kedvezmeny => <option nev={kedvezmeny.alanyNev} value={kedvezmeny.id}>{kedvezmeny.nev + ' (' + kedvezmeny.mertek + ' | ' + kedvezmeny.tipus + ', ' + kedvezmeny.alanyNev + ')'}</option>)]
    return options;
  }

  renderJegytipusok = () => {
    return this.state.tickets.map((ticketType) => {
      if (this.hasSelectedTicket()) {
        if (this.hasSelectedTicket() === ticketType.sec) {
          return (
            <Card
              className='user-select-none'
              style={{
                padding: 5,
                marginTop: 10,
                marginBottom: 10,
                backgroundColor: '#fff',
                color: '#212529',
                cursor: 'pointer',
                textAlign: 'center',
                borderRadius: '5px',
                boxShadow: '0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%)'
              }}
              onClick={ () => {
                this.setJegytipusok(ticketType.tid, ticketType.nam, ticketType.pri, ticketType.dis, ticketType.idn);
              }}
            >
              <CardBody>
                <CardTitle>
                  {ticketType.nam}
                  {ticketType.pub ? '': <i className="fa fa-lock pull-right" aria-hidden="true" style={{ color: 'red' }} />}
                </CardTitle>
                <CardSubtitle>{NumberFormatter.formatterSpaceOsszeg(ticketType.pri) + ' ' + ticketType.cur}</CardSubtitle>
              </CardBody>
            </Card>
          );
        }
      }
    });
  }

  // getPurchaseObj = () => {
  //   return {
  //     ste: this.state.currentStep,
  //     now: this.state.init.now,
  //     eid: this.state.event.eid,
  //     rid: this.state.event.rid,
  //     nam: this.state.formNev,
  //     ema: this.state.formEmail,
  //     seattickets: this.state.bucket,
  //     rot: this.isFoglalasOrVasarlas(),
  //     pty: this.getPaymenType(),
  //   }
  // }

  handleSubmitType = (name) => {
    this.setState({
      buttonLoading: true
    }, () => {
      let bucket = [];
      let seattickets = [];

      switch (name) {
        case 'HELYSZINI_FOGLALAS':
          bucket = JSON.parse(JSON.stringify(this.state.bucket));
          seattickets = [];

          bucket.forEach(bucketItem => {
            seattickets.push({
              tdi: null,
              tid: bucketItem.ttid,
              sid: bucketItem.sid,
            });
          })

          Services.sendAdminPurchase({
            ste: 1,
            eid: this.state.event.eid,
            now: this.state.init.now,
            rot: name,
            seattickets: seattickets,
            fizmodok: CONSTANTS.fizetesiModAzonositok,
          }, false, this.state.eszkozazonosito, (err, res) => {
            if (!err) {
              let event = JSON.parse(JSON.stringify(this.state.event))
              event.rid = res[0].rendeles.rid;

              bucket.forEach(bucketItem => {
                let seat = res[0].rendeles.seattickets.find(x => bucketItem.sid === x.sid && bucketItem.tid === bucketItem.tid);
                bucketItem.id = seat && seat.id;
              });

              this.setState({
                rot: res[0].rendeles.rot,
                ron: res[0].rendeles.ron,
                event: event,
                bucket: bucket,
                // isFoglalasModalOpen: true,
                buttonLoading: false
              })
              this.toggleFoglalasModal();
            } else {
              this.setState({ buttonLoading: false });
            }
          });
          break;
        case 'HELYSZINI_VASARLAS':
          bucket = JSON.parse(JSON.stringify(this.state.bucket));
          seattickets = [];

          bucket.forEach(bucketItem => {
            seattickets.push({
              tdi: null,
              tid: bucketItem.ttid,
              sid: bucketItem.sid
            });
          })

          Services.sendAdminPurchase({
            ste: 1,
            eid: this.state.event.eid,
            now: this.state.init.now,
            rot: name,
            seattickets: seattickets,
            fizmodok: CONSTANTS.fizetesiModAzonositok,
          }, false, this.state.eszkozazonosito, (err, res) => {
            if (!err) {
              let event = JSON.parse(JSON.stringify(this.state.event))
              event.rid = res[0].rendeles.rid;

              bucket.forEach(bucketItem => {
                let seat = res[0].rendeles.seattickets.find(x => bucketItem.sid === x.sid && bucketItem.tid === bucketItem.tid);
                bucketItem.id = seat && seat.id;
              })

              this.setState({
                rot: res[0].rendeles.rot,
                ron: res[0].rendeles.ron,
                event: event,
                bucket: bucket,
                isOsszegzesNezet: true,
                buttonLoading: false
              })
            } else {
              this.setState({ buttonLoading: false });
            }
          });
          break;
        default:
          break;
      }
    })
  }

  handlePurchaseFoglalas = () => {
    this.setState({ foglalasButtonLoading: true }, () => {
      const seattickets = [];

      this.state.aktivRendeles.jegyadatok.forEach(ticket => {
        if (ticket.jegyAllapot === 'Létrehozott') {
          let szekId = null;
          for(const line of this.state.layout.blocks) {
            const foundSeat = line.seats.find(x => x.tid === ticket.helyId);
            if(foundSeat) {
              szekId = foundSeat.id;
              break;
            }
          }

          seattickets.push({
            id: szekId,
            sid: ticket.helyId,
            tid: ticket.jegyTipusId || null,
            tdi: null,
          });
        }
      });

      Services.sendAdminPurchasePay2({
        ste: 2,
        eid: this.state.event.eid,
        now: this.state.init.now,
        seattickets: seattickets,
        rot: this.state.aktivRendeles.rendelesTipus,
        rid: this.state.aktivRendelesId,
        fizmodok: CONSTANTS.fizetesiModAzonositok,
      }, false, (err, res) => {
        if (!err) {
          const event = JSON.parse(JSON.stringify(this.state.event));
          event.rid = this.state.aktivRendelesId || res[0].rendeles.rid;

          // window.location.href = `${this.props.globals.public_url}/admin/jegyertekesites/helysziniertekesites/rendeles/${this.state.aktivRendelesId}`;
          flushSync(() => {
            this.props.globals.route.navigate(`${this.props.globals.public_url}/admin/test`, { replace: true, relative: 'path' });
          });
          flushSync(() => {
            this.props.globals.route.navigate(
              `${this.props.globals.public_url}/admin/jegyertekesites/helysziniertekesites/rendeles/${this.state.aktivRendelesId}`,
              { replace: true, relative: 'path' }
            );
          });
          // this.props.globals.route.navigate(0);

          // this.setState({
          //   rot: res[0].rendeles.rot,
          //   event: event,
          //   isOsszegzesNezet: true,
          //   foglalasButtonLoading: false
          // });
        } else {
          this.setState({ foglalasButtonLoading: false });
        }
      });
    });
  }

  onFoglalasVeglegesites = () => {
    this.setState({ foglalasButtonLoading: true }, () => {
      let bucket = JSON.parse(JSON.stringify(this.state.bucket));
      let seattickets = [];

      bucket.forEach(bucketItem => {
        seattickets.push({
          id: bucketItem.id,
          tdi: null,
          tid: bucketItem.ttid,
          sid: bucketItem.sid
        });
      })

      Services.sendAdminPurchase({
        ste: 2,
        rid: this.state.event.rid,
        eid: this.state.event.eid,
        now: this.state.init.now,
        rot: this.state.rot.name,
        nam: this.state.formNev,
        ema: this.state.formEmail,
        rno: this.state.formBizonylatszam,
        not: this.state.formMegjegyzes,
        seattickets: seattickets,
        fizmodok: CONSTANTS.fizetesiModAzonositok,
      }, false, this.state.eszkozazonosito, (err, res) => {
        if (!err) {
          let event = JSON.parse(JSON.stringify(this.state.event))
          // event.rid = res[0].rendeles.rid;

          this.setState({
            event: event,
            isFoglalasModalOpen: false,
            foglalasButtonLoading: false
          }, () => {
            this.props.dismissPortal();
            document.body.classList.remove("sidebar-hidden");
            this.props.globals.route.navigate(`${this.props.globals.public_url}/admin/jegyertekesites/helysziniertekesites`);
          })
        } else {
          this.setState({ foglalasButtonLoading: false });
        }
      });
    });
  }

  handleJegytipusChange = (e, item, index) => {
    let price = this.getPriceByTicketTypeId(e.target.value)
    let dis = this.getDiscountByTicketTypeId(e.target.value);
    let bucket = JSON.parse(JSON.stringify(this.state.bucket));
    let ticket = this.state.tickets.find(ticket => ticket.tid == e.target.value);

    bucket.forEach(bucketItem => {
      if (item.sid === bucketItem.sid) {
        bucketItem.dis = dis;
        bucketItem.did = '';
        bucketItem.kedvezmeny = null;
        bucketItem.ttid = e.target.value;
        bucketItem.pri = price;
        bucketItem.idn = ticket.idn;
      }
    })

    this.setState({
      bucket: bucket,
      isFoglalasModalOpen: false,
      veglegesitesButtonLoading: false
    })

  }

  handleKedvezmenyChange = (value, item) => {
    let formAlanyMap = {...this.state.formAlanyMap};
    let kedvezmeny = null;
    if (value) {
      let kedvezmenyList = [
        ...this.state.formKedvezmenyListByJegyTipus[item.sid][item.idn]
      // , ...this.state.formKedvezmenyListSzemely
    ];
      kedvezmeny = kedvezmenyList.find(kedvezmeny => kedvezmeny.id == value);
      formAlanyMap[item.id] = kedvezmeny.alanyId;
      this.setState({ formAlanyMap, formAlanyId: kedvezmeny.alanyId });
    } else {
      formAlanyMap[item.id] = undefined;
      this.setState({ formAlanyMap });
    }
    let bucket = [...this.state.bucket];
    bucket.forEach(bucketItem => {
      if (item.sid === bucketItem.sid) {
        item.kedvezmeny = kedvezmeny;
        item.did = value;
      }
    });
    let formKedvezmenyValueBySid = {...this.state.formKedvezmenyValueBySid};
    formKedvezmenyValueBySid[item.sid] = value;
    this.setState({ bucket, formKedvezmenyValueBySid });
  }

  isPaymentActive = (paymentId) => {
    return this.state.formFizetesiMod === paymentId;
  }

  renderPaymentCards = () => {
    return this.state.init.fizmod && this.state.init.fizmod.map((item) => {
      return (
        <Card
          className='user-select-none'
          style={{
            padding: 0,
            marginTop: 10,
            marginBottom: 10,
            marginRight: 10,
            backgroundColor: CONSTANTS.fizetesiModSzinkodok[item.kod][this.isPaymentActive(item.id) ? 1 : 0],
            color: '#212529',
            cursor: 'pointer',
            border: this.isPaymentActive(item.id) ? 'solid gray' : null,
            width: '150px',
            textAlign: 'center',
            borderRadius: '5px',
            boxShadow: '0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%)'
          }}
          onClick={ () => {
            this.setState({
              formFizetesiMod: item.id
            })
          }}
        >
          <CardBody>
            <CardTitle>
              {item.nev}
            </CardTitle>
          </CardBody>
        </Card>
      );
    });
  }

  getBucketPrice = () => {
    if(this.state.aktivRendeles) {
      return this.state.aktivRendeles.jegyadatok.reduce((acc, curr) => acc + curr.jegyAr, 0);
    }

    let price = 0;

    this.state.bucket.forEach(bucketItem => {
      price += this.getCorrectPrice(bucketItem.pri, bucketItem.kedvezmeny, bucketItem.ttid);
    });

    return price;
  }

  getPriceByTicketTypeId = (id) => {
    let price = 0;
    let ticketTypes = JSON.parse(JSON.stringify(this.state.tickets));

    ticketTypes.forEach(element => {
      if (element.tid === id) {
        price = element.pri
      }
    });

    return price;
  }

  getFixarByTicketTypeId = (id) => {
    let fpr = 0;
    let ticketTypes = JSON.parse(JSON.stringify(this.state.tickets));

    ticketTypes.forEach(element => {
      if (element.tid === id) {
        fpr = element.fpr ? element.fpr : 0
      }
    });

    return fpr;
  }

  getDiscountByTicketTypeId = (id) => {
    let dis = false;
    let ticketTypes = JSON.parse(JSON.stringify(this.state.tickets));

    ticketTypes.forEach(element => {
      if (element.tid === id) {
        dis = element.dis
      }
    });

    return dis;
  }

  loadVasarloiKartyaOptions = (v, item) => {
    const { sid } = item;
    // Kérésre a volt listázó csak pontos azonosítókra kell, hogy "listázzon", ezért select helyett egy sima RFField lett alkalmazva,
    // így viszont a select objektum kezelése a formVasarloiKartyaBySid segítségével van helyettesítve, ami id-t mappel minden sorhoz
    // (a sorok sid alapján vannak azonosítva, a beírt azonosító a keresésen túl haszontalan, ezért van csak az id lementve)
    Services.listVasarloiKartyaAzons(v, true, true, (err, res) => {
      if (!err) {
        this.setState(prevState => {
          let { formVasarloiKartyaBySid } = prevState;
          if (res[0].length == 1)
            formVasarloiKartyaBySid[sid] = res[0][0];
          else
            formVasarloiKartyaBySid[sid] = null;
          return { formVasarloiKartyaBySid }
        }, () => {
          this.handleVasarloiKartyaChange(this.state.formVasarloiKartyaBySid[sid]?.id, item);
        });
      }
    });
  }

  getKedvezmeny = (tid, did) => {
    this.setState({ kedvezmenyButtonLoading: true });
    Services.getDiscounts(tid, did, this.state.event.eid, this.state.isRendeles, (err, res) => {
      if (!err) {
        this.setState({ kedvezmenyButtonLoading: false });
        if (res[0].length < 1) {
          this.props.globals.addWarning('A kiválasztott azonosítóhoz nem érvényesíthető kedvezmény!');
        } else {
          this.setState({
            isKedvezmenyModalOpen: true,
            kedvezmenyList: res[0]
          })
        }
      } else {
        this.setState({ kedvezmenyButtonLoading: false });
      }
    });
  }

  setKedvezmeny = () => {
    if (this.state.activeKedvezmeny.id) {
      const bucket = JSON.parse(JSON.stringify(this.state.bucket));
      let newBucket = [];

      bucket.forEach(bucketItem => {
        if (this.state.currentSeatId === bucketItem.sid) {
          bucketItem.kedvezmeny = this.state.activeKedvezmeny;
        }
        newBucket.push(bucketItem);
      });

      this.setState({
        bucket: newBucket,
      }, () => {
        this.setState({
          isKedvezmenyModalOpen: false,
          activeKedvezmeny: {
            azonosito: null,
            ertek: null,
            ervenyes: false,
            id: null,
            nev: null,
            szazalek: null,
          },
          kedvezmenyList: []
        })
      });
    } else {
      this.props.globals.addWarning('Kedvezmény kiválasztása kötelező!');
    }
  }

  deleteKedvezmeny = (sid) => {
    const bucket = JSON.parse(JSON.stringify(this.state.bucket));
    let newBucket = [];

    bucket.forEach(bucketItem => {
      if (sid === bucketItem.sid) {
        bucketItem.kedvezmeny = null;
        bucketItem.did = '';
      }
      newBucket.push(bucketItem);
    });

    this.setState({
      bucket: newBucket
    });
  }

  setActiveKedvezmeny = (kedvezmeny) => {
    kedvezmeny.tdd = this.state.currentDiscountId;
    this.setState({
      activeKedvezmeny: kedvezmeny
    })
  }

  isKedvezmenyActive = (kedvezmenyId) => {
    return this.state.activeKedvezmeny.id === kedvezmenyId;
  }

  renderKedvezmenyek = () => {
    return this.state.kedvezmenyList.map((kedvezmeny) => {
      return (
        <Card
          style={{
            padding: 0,
            marginTop: 10,
            marginBottom: 10,
            backgroundColor: this.isKedvezmenyActive(kedvezmeny.id) ? '#ffeabe' : '#fff',
            color: '#212529',
            cursor: 'pointer'
          }}
          onClick={() => {
            this.setActiveKedvezmeny(kedvezmeny);
          }}
        >
          <CardBody>
            <CardTitle>
              {kedvezmeny.nev}
            </CardTitle>
            {kedvezmeny.osszeg && (
              <CardSubtitle>{kedvezmeny.osszeg + ' ' + this.state.defaultCurrency}</CardSubtitle>
            )}
            {kedvezmeny.szazalek && (
              <CardSubtitle>{kedvezmeny.szazalek + ' %'}</CardSubtitle>
            )}
          </CardBody>
        </Card>
      );
    });
  }

  getCorrectPrice = (price, kedvezmeny, tid) => {
    if (kedvezmeny) {
      if (kedvezmeny.osszeg) {
        let discountPrice = price - kedvezmeny.osszeg;
        return discountPrice < this.getFixarByTicketTypeId(tid) ? this.getFixarByTicketTypeId(tid) : discountPrice;
      }
      if (kedvezmeny.szazalek) {
        let priceWithoutFix = price - this.getFixarByTicketTypeId(tid);
        let discountPrice = price - (priceWithoutFix * (kedvezmeny.szazalek / 100));
        return discountPrice < this.getFixarByTicketTypeId(tid) ? this.getFixarByTicketTypeId(tid) : discountPrice;
      }
    } else {
      return price;
    }
  }

  mySubmitHandler = (event, did, sid, ttid) => {
    event.preventDefault();
    this.setState({
      currentDiscountId: did,
      currentSeatId: sid
    }, () => {
      this.getKedvezmeny(ttid, did);
    });
  }

  goBack = () => {
    this.setState({ ron: null });
    this.props.dismissPortal()
    this.props.globals.route.navigate(`${this.props.globals.public_url}/admin/jegyertekesites/helysziniertekesites`);
  }

  hasErvenyesitettJegy = () => {
    let result = false;
    let aktivCopy = JSON.parse(JSON.stringify(this.state.aktivRendeles));

    if(aktivCopy && aktivCopy.jegyadatok) {
      aktivCopy.jegyadatok.forEach(jegy => {
       if(jegy.jegyAllapot === "Érvényesített") result = true;
      });
    }
    return result;
  }

  render() {
    let cardStyle = {
      padding: 10
    };

    const {
      activeSectors,
      currentStep,
      formMegvasarlas,
      formFoglalas,
      formBarion,
      formRot,
      bucket,
      event,
      layout,
      init,
      redirectStatus,
      formVasarloiKartyaBySid,
      formKedvezmenyListByJegyTipus,
      formKedvezmenyValueBySid
     } = this.state;

    let isVasarlas = this.state.isOsszegzesNezet && !this.state.isRendeles;
    let visszaGombProps = isVasarlas && {
      color: 'danger',
      className: 'table-new-button',
      style:{ backgroundColor: '#f86c6b', border: 'none' }
    };

    let visszaGomb = <>
      <Button
        disabled={this.state.visszatorlesButtonLoading}
        {...visszaGombProps}
        onClick={() => {
          document.body.classList.remove("sidebar-hidden");
          this.state.isOsszegzesNezet && !this.state.isRendeles && !this.state.aktivRendeles ? (
            this.setState({
              visszatorlesButtonLoading: true
            }, () => {
              Services.deleteOrder(this.state.event.rid, this.state.eszkozazonosito, true, (err, res) => {
                if (!err) {
                  this.setState({ visszatorlesButtonLoading: false }, () => {
                    this.goBack();
                    // this.props.dismissPortal();
                    // this.props.globals.route.navigate("/ui/admin/jegyertekesites/helysziniertekesites");
                  });
                } else {
                  this.setState({ visszatorlesButtonLoading: false });
                }
              })
            })
          ) : (
            Services.wsSend('/kulsomonitor',this.state.eszkozazonosito, (err, res) => {
              if (!err) {
                if (this.state.event.rid) {
                  Services.orderBack(this.state.event.rid, this.state.ros, (err) => {
                    if (!err) {
                      this.goBack();
                    } else {
                      this.setState({ visszatorlesButtonLoading: false });
                    }
                  });
                } else {
                  this.goBack();
                }
              }
            })
          );
        }}
      >
        {this.state.isOsszegzesNezet && !this.state.isRendeles && !this.state.aktivRendeles ? 'Rendelés törlése' : 'Vissza'}
      </Button>
    </>;

    return (
      <div>
        <div className="animated fadeIn">
          <div className="row" style={cardStyle}>
            <div className="col-md-12 col-lg-8" style={{ marginBottom: 10 }}>
              {!this.state.isOsszegzesNezet && visszaGomb}
              <div>
                <span style={{ fontWeight: 800 , color: '#8a71cc', fontSize: '1.75rem', marginBottom: '.6em'}}>
                  {'Helyszín: '}
                  <span style={{ color: '#212529'}}>
                    {this.emptyFormatter(layout.vna)}
                  </span>
                </span>
              </div>
              <span style={{ fontWeight: 600 , color: '#212529', fontSize: '1.5rem', marginBottom: '.6em'}}>
                {this.emptyFormatter(event.nam) + ' | ' +  (event.sta ? TimeFormatter.formatLLLL(event.sta) : '-') + ' | ' + this.emptyFormatter(layout.hna) + (event.pub ? ' ' : ' | ')}
                {(event.pub ? '' : <i className="fa fa-lock" aria-hidden="true" style={{ color: 'red' }} />)}
                </span>
              {' '}
            </div>
            {this.state.isOsszegzesNezet && 
              <div className='col-md-12 col-lg-4' style={{ textAlign: 'right' }}>
                <span style={{ fontWeight: 600 , color: '#212529', fontSize: '1.5rem', marginBottom: '.6em' }}>
                  Rendelésszám: {this.emptyFormatter(this.state.ron)}
                </span>
              </div>
            }
            {this.state.isOsszegzesNezet ? (
              <React.Fragment>
                <iframe name="pdf-area-helyszin" id="pdf-area-helyszin" src={this.state.fileURL} style={{ visibility: 'hidden', height: 0, width: 0 }} />
                <div className="col-md-12 col-lg-12" style={{ marginTop: 20, marginBottom: 20 }}>
                  <h4>Személyes adatok megadása:</h4>
                  <RFForm onSubmit={() => {}} style={{ marginLeft: 8 }}>
                    <div className="row">
                      <div className="col-md-2 col-lg-2">
                          {/* Akkor lesz letiltva a mező, ha bármelyik kiválasztott kedvezmény személyhez van kötve (van alanyId) */}
                          <RFField label={t`Név: `} name="formNev" id="formNev" autoComplete="off" forcedValue={this.state.formNev} disabled={Object.values(this.state.formAlanyMap).some(alanyId => !!alanyId)} onChange={this.handleInputChange} />
                      </div>
                      <div className="col-md-2 col-lg-2">
                          <RFField label={'E-mail: '} name="formEmail" id="formEmail" autoComplete="off" value={this.state.formEmail} onChange={this.handleInputChange} />
                      </div>
                      <div className="col-md-2 col-lg-2">
                          <RFField label={'Bizonylatszám: '} name="formBizonylatszam" id="formBizonylatszam" autoComplete="off" value={this.state.formBizonylatszam} onChange={this.handleInputChange} />
                      </div>
                      <div className="col-md-6 col-lg-6">
                          <RFField label={'Megjegyzés: '} name="formMegjegyzes" id="formMegjegyzes" value={this.state.formMegjegyzes} onChange={this.handleInputChange} />
                      </div>
                    </div>
                  </RFForm>
                </div>
                <RFForm onSubmit={() => {}}>
                  {bucket.map((item, index) => {
                    return (
                      <>
                        <div className='col-md-12 col-lg-12 row' style={{ display: index != 0 ? 'none' : ''}}>
                          <div className="col-md-3 col-lg-2" style={{ marginBottom: 20 }}>
                            <h4>Megrendelés:</h4>
                          </div>
                          <div className='col-md-8 row'>
                            <div className='col-md-3 col-lg-4'>
                              <h4>Jegytípus módosítás:</h4>
                            </div>
                            <div className='col-md-4 col-lg-3' style={{ paddingLeft: 15}}>
                              <h4>Kártya sorszám:</h4>
                            </div>
                            <div className='col-md-5 col-lg-5' style={{ paddingLeft: 30 }}>
                              <h4>Kedvezmény:</h4>
                            </div>
                          </div>
                          <div className="col-md-2 col-lg-2" style={{ paddingLeft: 50 }}>
                            <h4 style={{whiteSpace:'nowrap'}}>Fizetendő érték:</h4>
                          </div>
                        </div>
                        <div className="row" style={{ paddingLeft: '15px', marginBottom: 6 }}>
                          <div className="col-md-2">
                            <div style={{ padding: 15, border: '1px solid #e4e4e4', marginBottom: 6 }}>
                              {/*<b>{t`Szektor:`}</b><span>{' ' + 'TODO' + ', '}</span> */}
                              <b>{t`Hely:`}</b><span>{' ' + (item.lbp ? item.lbp : '') + ' ' + item.rowLabel + ', ' + (item.lsp ? item.lsp : '') + ' ' + item.lab + (item.lss ? item.lss : ' ') }</span>
                            </div>
                          </div>
                          <div className='col-md-8 row align-items-center'>
                            <div className="col-md-4">
                              <Input type="select" name="select" id="exampleSelect" value={item.ttid} onChange={(e) => this.handleJegytipusChange(e, item, index)} style={{ height: '52.6px' }}>
                                {this.getTicketTypesBySector(item.tid)}
                              </Input>
                            </div>
                            <div className="col-md-3">
                              {item.dis && 
                                <RFField
                                  name={"formVasarloiKartya"+item.sid}
                                  id={"formVasarloiKartya"+item.sid}
                                  onChange={_.debounce((e, v) => this.loadVasarloiKartyaOptions(v, item), 500)}
                                  value={this.state.formVasarloiKartyaBySid[item.sid]?.azonosito}
                                  style={{ height: '52.6px', fontSize: '1rem' }}
                                  hideFormGroup
                                  autoComplete="off"
                                />
                            }
                            </div>
                            <div className="col-md-5">
                              <form onSubmit={(e) => this.mySubmitHandler(e, item.did, item.sid, item.ttid)}>
                                {item.dis && (
                                  <>
                                    <Input
                                      type="select"
                                      name="select"
                                      id="exampleSelect"
                                      disabled={!item || !formKedvezmenyListByJegyTipus[item.sid] ||
                                        // this.state.formKedvezmenyListSzemely.length == 0 && 
                                        !formKedvezmenyListByJegyTipus[item.sid][item.idn] || formKedvezmenyListByJegyTipus[item.sid][item.idn].length == 0
                                      }
                                      onChange={(e) => this.handleKedvezmenyChange(e.target.value, item)} style={{ height: '52.6px' }}
                                      value={formKedvezmenyValueBySid[item.sid]}
                                    >
                                      <option value=''>Válassz kedvezményt...</option>
                                      {this.getKedvezmenyByJegytipus(item.idn, item.sid)}
                                    </Input>
                                    {/* <Input
                                      name="kedvezmenyAzonosito"
                                      id="kedvezmenyAzonosito"
                                      autocomplete="off"
                                      value={item.did}
                                      onChange={(e) => this.handleKedvezmenyInputChange(e, item.sid, item)}
                                      disabled={item.kedvezmeny}
                                      style={{ minHeight: 52.6, fontSize: '1rem' }}
                                    /> */}
                                  </>
                                )}
                                </form>
                            </div>
                            {/* <div className="col-md-2">
                            {item.dis && (
                              <React.Fragment>
                                <Button
                                  color="primary"
                                  disabled={this.state.kedvezmenyButtonLoading || item.kedvezmeny}
                                  onClick={() => {
                                    this.setState({
                                      currentDiscountId: item.did,
                                      currentSeatId: item.sid
                                    }, () => {
                                      this.getKedvezmeny(item.ttid, item.did);
                                    });
                                  }}
                                >
                                  <i className="fa fa-search" aria-hidden="true"></i>
                                </Button>
                                {' '}
                                {(item.kedvezmeny) && (
                                  <Button
                                    color="danger"
                                    style={{ marginTop: 16 }}
                                    onClick={() => {
                                      this.deleteKedvezmeny(item.sid);
                                    }}
                                  >
                                    <i className="fa fa-times" aria-hidden="true"></i>
                                  </Button>
                                )}
                              </React.Fragment>
                              )}
                            </div> */}
                          </div>
                          <div className="col-md-2">
                            <div style={{ padding: 15, border: '1px solid #e4e4e4', marginBottom: 6 }}>
                              {/*<b>{t`Szektor:`}</b><span>{' ' + 'TODO' + ', '}</span> */}
                              <span>{NumberFormatter.formatterSpaceOsszeg(this.getCorrectPrice(item.pri, item.kedvezmeny, item.ttid)) + ' ' + this.state.defaultCurrency}</span>
                            </div>
                          </div>
                        </div>
                      </>
                    )
                  })}
                </RFForm>
                <div className="col-md-12 col-lg-12">
                  <p className="pull-right" style={{ fontSize: '1.5rem' }}><b>Összesen fizetendő:</b>{' ' +  NumberFormatter.formatterSpaceOsszeg(this.getBucketPrice()) + ' ' + this.state.defaultCurrency}</p>
                </div>
                <div className="col-md-12 col-lg-12">
                  <span className="pull-right" style={{ display: "flex" }}>
                    <h4 style={{ position: "relative", top: "30px" }}>Fizetési mód: &nbsp;</h4>
                    {this.renderPaymentCards()}
                  </span>
                </div>
                <div className="col-md-12 col-lg-12 row no-gutters" style={{ marginTop: 16 }}>
                  <div className='col-md-6 col-lg-6'>
                    {visszaGomb}
                  </div>
                  <div className='col-md-6 col-lg-6'>
                    <Button
                      style={{ marginBottom: 8, marginRight: 8 }}
                      color="primary"
                      type="button"
                      disabled={this.state.fizetesNyomtatasNelkulButtonLoading}
                      className="pull-right table-new-button"
                      onClick={(e) => {
                        e.target.blur();

                        this.setState({ fizetesNyomtatasNelkulButtonLoading: true });

                        // const history = this.props.history;

                        let bucket = JSON.parse(JSON.stringify(this.state.bucket));
                        let seattickets = [];

                        bucket.forEach(bucketItem => {
                          seattickets.push({
                            tdd: formVasarloiKartyaBySid[bucketItem.sid] && formVasarloiKartyaBySid[bucketItem.sid].azonosito,
                            tdi: bucketItem.kedvezmeny && bucketItem.kedvezmeny.id,
                            tid: bucketItem.ttid,
                            sid: bucketItem.sid,
                            id: bucketItem.id,
                          });
                        })

                        window.removeEventListener("beforeunload", (e) => this.deleteOrder(e), false);
                        window.removeEventListener("popstate", (e) => this.deleteOrder(e), false);

                        // if (this.state.prevProps && this.state.prevProps.globals && this.state.prevProps.globals.route && this.state.prevProps.globals.route.location && this.state.prevProps.globals.route.location.state && this.state.prevProps.globals.route.location.state.rendelesId) {
                          // const { globals } = this.state.prevProps;
                          const { globals, rendelesId } = this.props;
                          const { route } = globals;
                          if (rendelesId) {
                            Services.sendAdminPurchasePay({
                              ste: 2,
                              rid: this.state.event.rid,
                              eid: this.state.event.eid,
                              now: this.state.init.now,
                              rot: this.state.rot.name,
                              nam: this.state.formNev,
                              pty: this.state.formFizetesiMod,
                              ema: this.state.formEmail,
                              rno: this.state.formBizonylatszam,
                              not: this.state.formMegjegyzes,
                              seattickets: seattickets,
                              fizmodok: CONSTANTS.fizetesiModAzonositok,
                            }, false, (err) => {
                              if (!err) {
                              this.props.dismissPortal()
                              // TODO
                              document.body.classList.remove("sidebar-hidden");
                              this.props.globals.route.navigate(`${this.props.globals.public_url}/admin/jegyertekesites/helysziniertekesites`);
                                this.setState({ fizetesNyomtatasNelkulButtonLoading: false });
                              } else {
                                this.setState({ fizetesNyomtatasNelkulButtonLoading: false });
                              }
                            });
                          } else {
                            Services.sendAdminPurchase({
                              ste: 2,
                              rid: this.state.event.rid,
                              eid: this.state.event.eid,
                              now: this.state.init.now,
                              rot: this.state.rot.name,
                              nam: this.state.formNev,
                              pty: this.state.formFizetesiMod,
                              ema: this.state.formEmail,
                              rno: this.state.formBizonylatszam,
                              not: this.state.formMegjegyzes,
                              seattickets: seattickets,
                              fizmodok: CONSTANTS.fizetesiModAzonositok,
                          }, false, this.state.eszkozazonosito, (err, res) => {
                            if (!err) {
                              this.goBack();
                              document.body.classList.remove("sidebar-hidden");
                              // this.props.dismissPortal()
                              // this.props.globals.route.navigate("/ui/admin/jegyertekesites/helysziniertekesites/");
                              this.setState({ fizetesNyomtatasNelkulButtonLoading: false });
                            } else {
                              this.setState({ fizetesNyomtatasNelkulButtonLoading: false });
                            }
                          });
                          }
                        }

                        // if (history && history.location && history.location.state && history.location.state.rendelesId) {
                        //   Services.sendAdminPurchasePay({
                        //     ste: 2,
                        //     rid: this.state.event.rid,
                        //     eid: this.state.event.eid,
                        //     now: this.state.init.now,
                        //     rot: this.state.rot.name,
                        //     nam: this.state.formNev,
                        //     pty: this.state.formFizetesiMod,
                        //     ema: this.state.formEmail,
                        //     rno: this.state.formBizonylatszam,
                        //     not: this.state.formMegjegyzes,
                        //     seattickets: seattickets,
                        //     fizmodok: CONSTANTS.fizetesiModAzonositok,
                        //   }, false, (err, res) => {
                        //     if (!err) {
                        //      this.props.dismissPortal()
                        //      // TODO
                        //      document.body.classList.remove("sidebar-hidden");
                        //      this.props.globals.route.navigate(`${this.props.globals.public_url}/admin/jegyertekesites/helysziniertekesites`);
                        //       this.setState({ fizetesNyomtatasNelkulButtonLoading: false });
                        //     } else {
                        //       this.setState({ fizetesNyomtatasNelkulButtonLoading: false });
                        //     }
                        //   });
                        //   } else {
                        //     Services.sendAdminPurchase({
                        //       ste: 2,
                        //    rid: this.state.event.rid,
                        //     eid: this.state.event.eid,
                        //     now: this.state.init.now,
                        //     rot: this.state.rot.name,
                        //     nam: this.state.formNev,
                        //     pty: this.state.formFizetesiMod,
                        //     ema: this.state.formEmail,
                        //     rno: this.state.formBizonylatszam,
                        //     not: this.state.formMegjegyzes,
                        //     seattickets: seattickets,
                        //     fizmodok: CONSTANTS.fizetesiModAzonositok,
                        //   }, false, this.state.eszkozazonosito, (err, res) => {
                        //     if (!err) {
                        //       this.goBack();
                        //       document.body.classList.remove("sidebar-hidden");
                        //       // this.props.dismissPortal()
                        //       // this.props.globals.route.navigate("/ui/admin/jegyertekesites/helysziniertekesites/");
                        //       this.setState({ fizetesNyomtatasNelkulButtonLoading: false });
                        //     } else {
                        //       this.setState({ fizetesNyomtatasNelkulButtonLoading: false });
                        //     }
                        //   });
                        // }
                      // }
                    }
                    >
                      {'Fizetés nyomtatás nélkül'}
                    </Button>
                    {' '}
                    <JegyeladasFizetesButton
                      fizetesButtonLoading={this.state.fizetesButtonLoading}
                      bucket={this.state.bucket}
                      event={this.state.event}
                      init={this.state.init}
                      rot={this.state.rot}
                      formNev={this.state.formNev}
                      formFizetesiMod={this.state.formFizetesiMod}
                      formEmail={this.state.formEmail}
                      formBizonylatszam={this.state.formBizonylatszam}
                      formMegjegyzes={this.state.formMegjegyzes}
                      formVasarloiKartyaBySid={this.state.formVasarloiKartyaBySid}
                      rendelesId={this.props.rendelesId}
                      eszkozazonosito={this.state.eszkozazonosito}
                      CONSTANTS={CONSTANTS}
                      setFizetesButtonLoading={(loading) => this.setState({ fizetesButtonLoading: loading })}
                      addSuccess={this.props.globals.addSuccess}
                      goBack={this.goBack}
                    />
                  </div>
                </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div className="col-md-6 col-lg-6" style={{ minHeight: 500 }}>
                  <SvgViewer
                    withSectorColors
                    zoomEnabled={false}
                    height="650px"
                    onKeyDown={this.onKeyDown}
                    onKeyUp={this.onKeyUp}
                    data={layout}
                    szektorok={init.sectors}
                    szinek={{
                      coa: init.coa,
                      con: init.con,
                      cop: init.cop
                    }}
                    aktivRendelesId={this.state.aktivRendelesId}
                    onTicketClick={this.onTicketClick}
                  />
                  <div style={{ paddingTop: 20 }}>
                    <Button
                      style={{ marginBottom: 8, marginRight: 8, color: 'white', backgroundColor: 'green', borderColor: 'transparent', cursor: 'default' }}
                      color="secondary"
                      type="button"
                      className="pull-left table-new-button"
                      onClick={(e) => {
                        e.target.blur();
                      }}
                    >
                      {'Szabad'}
                    </Button>
                    {' '}
                    <Button
                      style={{ marginBottom: 8, marginRight: 8, color: 'black', backgroundColor: 'yellow', borderColor: 'transparent', cursor: 'default' }}
                      color="secondary"
                      type="button"
                      className="pull-left table-new-button"
                      onClick={(e) => {
                        e.target.blur();
                      }}
                    >
                      {'Folyamatban'}
                    </Button>
                    {' '}
                    <Button
                      style={{ marginBottom: 8, marginRight: 8, color: 'white', backgroundColor: 'gray', borderColor: 'transparent', cursor: 'default' }}
                      color="secondary"
                      type="button"
                      className="pull-left table-new-button"
                      onClick={(e) => {
                        e.target.blur();
                      }}
                    >
                      {'Foglalt'}
                    </Button>
                    {' '}
                    <Button
                      style={{ marginBottom: 8, marginRight: 8, color: 'white', backgroundColor: 'purple', borderColor: 'transparent', cursor: 'default' }}
                      color="secondary"
                      type="button"
                      className="pull-left table-new-button"
                      onClick={(e) => {
                        e.target.blur();
                      }}
                    >
                      {'Barion'}
                    </Button>
                    {' '}
                    <Button
                      style={{ marginBottom: 8, marginRight: 8, color: 'white', backgroundColor: 'red', borderColor: 'transparent', cursor: 'default' }}
                      color="secondary"
                      type="button"
                      className="pull-left table-new-button"
                      onClick={(e) => {
                        e.target.blur();
                      }}
                    >
                      {'Fizetett'}
                    </Button>
                    {' '}
                    <Button
                      style={{ marginBottom: 8, marginRight: 8, color: 'white', backgroundColor: '#2196f3', borderColor: 'transparent', cursor: 'default' }}
                      color="secondary"
                      type="button"
                      className="pull-left table-new-button"
                      onClick={(e) => {
                        e.target.blur();
                      }}
                      >
                      {'Érvényesített'}
                    </Button>
                    {' '}
                  </div>
                </div>
                <div className="col-md-4 col-lg-4">
                  {this.state.aktivRendeles && (
                    <>
                      {(this.props.globals.hasRoleSpec(['JEGYVASARLAS_RENDELES_TORLES']) && (!this.hasErvenyesitettJegy())) && (
                        <div className="pull-right">
                          <ProgressButton
                            style={{ color: 'white', backgroundColor: 'red', borderColor: 'transparent', cursor: 'pointer' }}
                            color="secondary"
                            type="button"
                            className="table-new-button"
                            loading={false}
                            onClick={(e) => {
                              e.target.blur();
                              // console.log('aktiv', this.state.aktivRendeles)
                              this.handleDeleteClick(this.state.aktivRendelesId);
                            }}
                          >
                            Rendelés törlése
                          </ProgressButton>
                        </div>
                      )}
                      <h4 className='mb-1'>Rendelésszám: {this.emptyFormatter(this.state.ron)}</h4>
                      <ul className='d-flex flex-column' style={{ fontSize: 16, marginBottom: 16 }}>
                        <li>Név: <b>{this.state.aktivRendeles.rendeloNev}</b></li>
                        <li>E-mail: <b>{this.state.aktivRendeles.rendeloEmail}</b></li>
                        {/*<li style={{ color: 'red' }}>Állapot: <b>{this.state.aktivRendeles.rendelesAllapot}</b></li>*/}
                      </ul>
                    </>
                  )}
                  {!this.state.isOsszegzesNezet && (
                    <div style={{ fontWeight: 500 , color: '#212529', fontSize: '1.4rem', marginBottom: '.6em'}}>
                      {' Jegyek összesen: ' + (this.state.aktivRendeles ? this.state.aktivRendeles.jegyadatok.length : this.state.bucket.length) + ' db / ' + NumberFormatter.formatterSpaceOsszeg(this.getBucketPrice()) + ' ' + this.state.defaultCurrency}
                    </div>
                    )}
                  <h4>
                    Jegyek:
                  </h4>
                  {this.state.aktivRendelesLoading ? <Loader /> : !this.state.aktivRendeles && this.state.bucket.length < 1 ? <EmptyState title="" hasImage /> : this.renderBucket()}
                </div>
                <div className="col-md-2 col-lg-2">
                  <h4>
                    Jegytípus:
                  </h4>
                  <div style={{ minHeight: 300 }}>
                    {this.hasSelectedTicket() ? (
                      <div style={{ marginTop: 30 }}>
                        {this.renderJegytipusok()}
                      </div>
                    ) : (
                      <EmptyTypes hasImage />
                    )}
                  </div>

                  {(this.state.aktivRendeles) ? (
                    (this.state.aktivRendeles.rendelesAllapot === "Lefoglalt" || this.state.aktivRendeles.rendelesAllapot === "Foglalás részben törölve (Sikeres foglalás utáni)") && (
                      <ProgressButton
                      style={{ marginBottom: 8, marginRight: 8 }}
                      color="primary"
                      type="button"
                      className="pull-left table-new-button"
                      loading={this.state.foglalasButtonLoading}
                      onClick={(e) => {
                        e.target.blur();
                        this.handlePurchaseFoglalas()
                      }}
                    >
                      Vásárlás
                    </ProgressButton>
                    )
                  ) : (
                    <>
                      {this.state.init.rot.map((item) => {
                        return (
                          <ProgressButton
                            style={{ marginBottom: 8, marginRight: 8 }}
                            color="primary"
                            type="button"
                            className="pull-left table-new-button"
                            loading={this.state.buttonLoading}
                            onClick={(e) => {
                              e.target.blur();
                              this.handleSubmitType(item.name);
                            }}
                          >
                            {item.publiccaption}
                          </ProgressButton>
                        );
                      })}
                    </>
                  )}
                </div>
              </React.Fragment>
            )}
            <div className="col-md-12 col-lg-12" style={{ paddingTop: 20 }} />
          </div>
        </div>
        {/* <Modal isOpen={this.state.isFoglalasModalOpen} toggle={this.toggleFoglalasModal} backdrop="static"> */}
          {/* <ModalHeader>Foglalás</ModalHeader>
          <ModalBody> */}
            <React.Fragment>
              <Modal isOpen={this.state.isFoglalasModalOpen} toggle={this.toggleFoglalasModal} className={this.props.className} backdrop="static">
              <RFForm
                onSubmit={(e, values) => { console.log(values, e) ; /* this.onFoglalasVeglegesites(e, values) */}}
                // id="my-form"
                // modalInsert
                modal
                title={'Foglalás'}
                // tagProps={{ isOpen: this.state.isFoglalasModalOpen, toggle: this.toggleFoglalasModal, backdrop: 'static' }}
                footer={
                  <React.Fragment>
                    <ProgressButton
                      style={{ marginBottom: 8, marginRight: 8 }}
                      color="primary"
                      type="submit"
                      className="pull-left table-new-button"
                      loading={this.state.foglalasButtonLoading}
                      onClick={(e) => {
                        e.target.blur();
                        this.onFoglalasVeglegesites();
                      }}
                    >
                      {'Véglegesítés'}
                    </ProgressButton>
                    <ProgressButton
                      style={{ marginBottom: 8, marginRight: 8 }}
                      color="secondary"
                      type="button"
                      className="pull-left table-new-button"
                      loading={this.state.foglalasButtonLoading}
                      onClick={(e) => {
                        e.target.blur();
                        this.setState({
                          foglalasButtonLoading: true
                        }, () => {
                          Services.deleteOrder(this.state.event.rid, this.state.eszkozazonosito, false, (err, res) => {
                            if (!err) {
                              let eventNullRid = JSON.parse(JSON.stringify(this.state.event));
                              eventNullRid.rid = null;
                              this.toggleFoglalasModal();
                              this.setState({ foglalasButtonLoading: false, ron: null, event: eventNullRid });
                            } else {
                              this.setState({ foglalasButtonLoading: false });
                            }
                          });
                        });
                      }}
                    >
                      {'Mégsem'}
                    </ProgressButton>
                  </React.Fragment>
                }
              >
                  <p style={{ fontSize: '1.65rem' }}>Személyes adatok megadása:</p>
                  <RFField label={t`Név: *`} name="formNev" value={this.state.formNev} onChange={this.handleInputChange} required />
                  <RFField label={'E-mail: *'} name="formEmail" value={this.state.formEmail} onChange={this.handleInputChange} required />
                  <RFField label={'Bizonylatszám:'} name="formBizonylatszam" value={this.state.formBizonylatszam} onChange={this.handleInputChange} />
                  <RFField label={'Megjegyzés:'} name="formMegjegyzes" type="textarea" value={this.state.formMegjegyzes} onChange={this.handleInputChange} />
                  <p>* = {t`A mezők kitöltése kötelező`}</p>
              </RFForm>
              </Modal>
            </React.Fragment>

          {/* </ModalBody>
          <ModalFooter>
            <ProgressButton
              style={{ marginBottom: 8, marginRight: 8 }}
              color="primary"
              type="submit"
              className="pull-left table-new-button"
              loading={this.state.foglalasButtonLoading}
              onClick={(e) => {
                e.target.blur();
                // this.onFoglalasVeglegesites();
              }}
            >
              {'Véglegesítés'}
            </ProgressButton>
            <ProgressButton
              style={{ marginBottom: 8, marginRight: 8 }}
              color="secondary"
              type="button"
              className="pull-left table-new-button"
              loading={this.state.foglalasButtonLoading}
              onClick={(e) => {
                e.target.blur();
                this.setState({
                  foglalasButtonLoading: true
                }, () => {
                  Services.deleteOrder(this.state.event.rid, this.state.eszkozazonosito, false, (err, res) => {
                    if (!err) {
                      this.toggleFoglalasModal();
                      this.setState({ foglalasButtonLoading: false });
                    } else {
                      this.setState({ foglalasButtonLoading: false });
                    }
                  });
                });
              }}
            >
              {'Mégsem'}
            </ProgressButton>
          </ModalFooter> */}
        {/* </Modal> */}
        <Modal isOpen={this.state.isKedvezmenyModalOpen} toggle={this.toggleKedvezmenyModal} backdrop="static">
          <ModalHeader>Kedvezmény választása</ModalHeader>
          <ModalBody>
            {this.renderKedvezmenyek()}
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => {
                this.setKedvezmeny();
              }}
            >
              Mentés
            </Button>
            <Button type="button" className="btn-cursor-pointer" color="secondary" onClick={() => {
              this.setState({
                isKedvezmenyModalOpen: false,
                activeKedvezmeny: {
                  azonosito: null,
                  ertek: null,
                  ervenyes: false,
                  id: null,
                  nev: null,
                  szazalek: null,
                },
                kedvezmenyList: []
              });
            }}>
              Mégsem
            </Button>
          </ModalFooter>
        </Modal>
        <RFForm
          onSubmit={this.deleteRendeles}
          modalInsert
          title={'Törlés'}
          tagProps={{ isOpen: this.state.modalDelete, toggle: this.toggleDeleteModal, backdrop: 'static' }}
          footer={
            <React.Fragment>
              <ProgressButton
                className="btn-cursor-pointer"
                color="primary"
                onClick={() => this.deleteRendeles()}
                loading={this.state.deleteButtonLoading}
              >
                {'Törlés'}
              </ProgressButton>
              <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
            </React.Fragment>
          }
        >
          {/* <ModalHeader>Törlés</ModalHeader>
          <ModalBody> */}
            <div className="delete-title-text" style={{ marginBottom: 12 }}>Valóban törölni kívánod a kiválasztott rendelést?</div>
            {this.state.hasTorlesOka && (
              <RFField label={'Törlés oka: *'} name="formTorlesOka" id="formTorlesOka" required value={this.state.formTorlesOka} onChange={this.handleInputChange} />
            )}
          {/* </ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              // onClick={() => this.deleteRendeles()}
              loading={this.state.deleteButtonLoading}
            >
              {'Törlés'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
          </ModalFooter> */}
          </RFForm>
      </div>
    );
  }
}

JegyeladasContent.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default JegyeladasContent;
